const globalEvents = {
    OPEN_ERRORS: 'openErrorsInErrorPanel',
    UPDATE_SCRIPTS_PANEL: 'updateScriptsPanel',
    CM_ON_VARIABLE_MOUSE_IN: 'onVariableMouseInCm',
    CM_ON_VARIABLE_MOUSE_OUT: 'onVariableMouseOutCm',
};

export default globalEvents;